"use client"

import type { Discount } from "@apps/gwservice/types"
import { Drawer, DrawerContent, DrawerTitle } from "@mylaunch/components/ui"
import { Button } from "~/components/ui/button"
import { DrawerCover } from "~/components/ui/drawer-cover"

interface Props {
  discount: Discount | null
  onClose: () => void
}

export function DiscountSheet({ discount, onClose }: Props) {
  return (
    <Drawer open={!!discount} onOpenChange={(open) => !open && onClose()}>
      <DrawerContent handle={false} className="rounded-t-xl p-0 gap-0 border-0 outline-none">
        <DrawerTitle className="sr-only">{discount?.partner}</DrawerTitle>
        {discount && (
          <>
            {discount.cover && <DrawerCover imageUrl={discount.cover.url} mimeType={discount.cover.mimeType} />}
            <div className="flex flex-col gap-s p-m mb-m">
              <div className="font-semibold text-lg">{discount.partner}</div>
              <div lang="ru" className="hyphens-auto">
                {discount.text}
              </div>
            </div>
            <Button asChild size="lg" className="sticky bottom-m mx-m !w-auto" variant="default">
              <a href={discount.link} target="_blank" rel="noopener noreferrer">Перейти на сайт</a>
            </Button>
          </>
        )}
      </DrawerContent>
    </Drawer>
  )
}
